import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

function getContainer(container) {
  return ReactDOM.findDOMNode(typeof container === 'function' ? container() : container);
}

export const Portal = React.forwardRef(function Portal(
  { children, container, disablePortal = false, onRendered },
  ref
) {
  const [mountNode, setMountNode] = React.useState(getContainer(container) || document.body);

  useEffect(() => {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);

  useEffect(() => {
    if (mountNode && !disablePortal && ref) {
      ref.current = mountNode;
      return () => {
        ref.current = null;
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);

  useEffect(() => {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if (React.isValidElement(children)) {
      return React.cloneElement(children);
    }
    return children;
  }

  return mountNode ? ReactDOM.createPortal(children, mountNode) : mountNode;
});
